import { applyName } from './captureMode';

export const CUSTOMER_CATEGORY_CLIENTE = 'cliente';

export const CUSTOMER_CATEGORY_OPTIONS = [
    { value: 'cliente', label: 'Cliente' },
    { value: 'parceiro', label: 'Parceiro' },
    { value: 'vendedor', label: 'Vendedor' },
    { value: 'afiliado', label: 'Afiliado' },
];

export const DEFAULT_CUSTOMER_SORT_BY = 'created_at';
export const DEFAULT_CUSTOMER_SORT_ORDER = 'desc';

const CATEGORY_LABELS = Object.fromEntries(
    CUSTOMER_CATEGORY_OPTIONS.map((option) => [option.value, option.label]),
);

/** Cores distintas para categorias que não são o padrão Cliente. */
export const CUSTOMER_CATEGORY_COLORS = {
    parceiro: {
        color: 'info',
        sx: { bgcolor: 'info.dark', color: 'info.contrastText' },
    },
    vendedor: {
        color: 'warning',
        sx: { bgcolor: 'warning.dark', color: 'warning.contrastText' },
    },
    afiliado: {
        color: 'secondary',
        sx: { bgcolor: 'secondary.dark', color: 'secondary.contrastText' },
    },
};

export function normalizeCustomerCategory(value) {
    const raw = String(value || '').trim().toLowerCase();
    if (raw === 'parceiro' || raw === 'vendedor' || raw === 'afiliado') {
        return raw;
    }
    return CUSTOMER_CATEGORY_CLIENTE;
}

export function customerCategoryLabel(value) {
    const category = normalizeCustomerCategory(value);
    return CATEGORY_LABELS[category] || CATEGORY_LABELS[CUSTOMER_CATEGORY_CLIENTE];
}

export function formatCustomerDisplayName(customerOrName, category) {
    const name = typeof customerOrName === 'string'
        ? customerOrName
        : (customerOrName?.name || '');
    const resolvedCategory = normalizeCustomerCategory(
        typeof customerOrName === 'string' ? category : (category ?? customerOrName?.category),
    );
    const visibleName = name ? (applyName(name) || name) : '';
    if (!visibleName) {
        return resolvedCategory === CUSTOMER_CATEGORY_CLIENTE
            ? '—'
            : `${customerCategoryLabel(resolvedCategory)} - —`;
    }
    if (resolvedCategory === CUSTOMER_CATEGORY_CLIENTE) {
        return visibleName;
    }
    return `${customerCategoryLabel(resolvedCategory)} - ${visibleName}`;
}

export function isHighlightedCustomerCategory(value) {
    return normalizeCustomerCategory(value) !== CUSTOMER_CATEGORY_CLIENTE;
}
